import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VehiclesPage from './pages/VehiclesPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import AddVehiclePage from './pages/AddVehiclePage';
import EditVehiclePage from './pages/EditVehiclePage';
import MyVehiclesPage from './pages/MyVehiclesPage';
import ProfilePage from './pages/ProfilePage';
import ProfileEditPage from './pages/ProfileEditPage';
import ApplicationPage from './pages/ApplicationPage';
import AdminImportDataPage from './pages/AdminImportDataPage';
import Contact from './pages/Contact';
import { AuthProvider, useAuth } from './context/AuthContext';
import AboutUs from './pages/AboutUs';
import FAQPage from './pages/FAQPage';
import SalesSystem from './pages/SalesSystem';
import CookiePolicy from './pages/CookiePolicy'; // Yeni eklenen import
import KVKKForm from './pages/KVKKForm'; // Yeni eklenen import
import ReportGeneratorPage from './pages/ReportGeneratorPage';
import ReportsPage from './pages/ReportsPage';



// Korumalı Route bileşeni
const ProtectedRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    if (loading) return <div>Yükleniyor...</div>;
    if (!currentUser) {
        return <Navigate to="/login" />;
    }
    return children;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <ScrollToTop />
                <div className="App">
                    <Header />
                    <main>
                        <Routes>
                            {/* Ana rotalar */}
                            <Route path="/" element={<HomePage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/about" element={<AboutUs />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/sales-system" element={<SalesSystem />} />
                            
                            {/* Politika sayfaları - Yeni eklenen */}
                            <Route path="/cerez-politikasi" element={<CookiePolicy />} />
                            <Route path="/kvkk-aydinlatma-formu" element={<KVKKForm />} />

                            {/* Admin rota */}
                            <Route path="/admin/import-vehicle-data" element={<AdminImportDataPage />} />

                            {/* Araç listeleme */}
                            <Route path="/vehicles" element={<VehiclesPage />} />

                            {/* Başvuru sayfası */}
                            <Route path="/application" element={<ApplicationPage />} />
                            <Route path="/apply" element={<ApplicationPage />} />

                            {/* Araç detay sayfası - Normal ve sayısal ID desteği */}
                            <Route path="/vehicles/:id" element={<VehicleDetailPage />} />

                            {/* Sayısal ID için alternatif rotalar (örn: /vehicle/1, /vehicle/2) */}
                            <Route path="/vehicle/:customId" element={<VehicleDetailPage />} />

                            {/* Korumalı rotalar */}
                            <Route path="/add-vehicle" element={
                                <ProtectedRoute>
                                    <AddVehiclePage />
                                </ProtectedRoute>
                            } />

                            {/* Route tanımları */}
                            <Route path="/report-generator" element={
                                <ProtectedRoute>
                                    <ReportGeneratorPage />
                                </ProtectedRoute>
                            } />

                            <Route path="/reports" element={
                                <ProtectedRoute>
                                    <ReportsPage />
                                </ProtectedRoute>
                            } />

                            {/* Araç düzenleme rotaları - Hem normal hem de sayısal ID desteği */}
                            <Route path="/vehicles/edit/:id" element={
                                <ProtectedRoute>
                                    <EditVehiclePage />
                                </ProtectedRoute>
                            } />
                            <Route path="/edit-vehicle/:id" element={
                                <ProtectedRoute>
                                    <EditVehiclePage />
                                </ProtectedRoute>
                            } />
                            <Route path="/vehicle/edit/:customId" element={
                                <ProtectedRoute>
                                    <EditVehiclePage />
                                </ProtectedRoute>
                            } />

                            {/* Kullanıcının kendi araçları */}
                            <Route path="/my-vehicles" element={
                                <ProtectedRoute>
                                    <MyVehiclesPage />
                                </ProtectedRoute>
                            } />

                            {/* Profil sayfası rotaları */}
                            <Route path="/profile" element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            } />
                            <Route path="/profile/edit" element={
                                <ProtectedRoute>
                                    <ProfileEditPage />
                                </ProtectedRoute>
                            } />

                            {/* Bulunamayan sayfalar için ana sayfaya yönlendirme */}
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;